import _ from 'lodash';
import async from 'async';
//import moment from "moment-timezone";
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';

//- material
import { withStyles } from '@material-ui/core/styles';
import LocationSelect from "../../components/advancedForm/LocationSelect";
import DriverRoomBody from "../../components/FleetCalendar/DriverRoomBody";
import moment from "moment-timezone";
import {post} from "../../modules/utility";
import {getNumberOfDaysBreakPoint} from "../../libs/calendarConfig";
import ShiftSelect from "../../components/advancedForm/ShiftSelect";
import AuthUserContainer from "../../containers/AuthUser";
import FormCheckbox from "../../components/form/FormCheckbox";
//import WarningIcon from "@material-ui/icons/Warning";

const styles = () => {

	//const fw = 1280;
	//const fh = 1664;

	//const iw = 1088;
	//const ih = 1472;

	const p = v => { return `${v * 100}%`; };
	//const pw = v => { return `${(v/iw) * 100}%`; };
	//const ph = v => { return `${(v/ih) * 100}%`; };
	//const lineColor = '#ccc';
	return {
		root : {
			//position : 'absolute',
			backgroundColor : 'white',
			height: '100%',
			width : '100%',
			//padding : `${p(0.07)} ${p(0.095)} 0 ${p(0.095)}`,
			boxSizing : 'border-box',
			fontFamily: "Roboto",
			fontSize : '.6vw',
		},
		aspectRatio : {
			position : 'fixed',
			width: '100%',
			paddingBottom : '129.411%',
			//background: 'gold',
			top : 0,
			left : 0,
		},
		pageBackground : {
			position : 'fixed',
			width: '100%',
			height : '100%',
			background: 'white',
			top : 0,
			left : 0,
		},
		inner : {
			position: 'relative',
			height: '100%',
			width: '100%',
			//border : '1px solid red',
		},
		noLocationIdContainer : {
			//position : 'absolute',
			backgroundColor : 'white',
			height: '100%',
			width : '100%',
			padding : `${p(0.07)} ${p(0.095)} 0 ${p(0.095)}`,
			boxSizing : 'border-box',
			fontFamily: "Roboto",
			fontSize : '1.0vw',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
		},
		noLocationInner : {
			position: 'relative',
			height: '100%',
			width: '100%',
			maxWidth : 600,
		}
	};
};

function getControlDisplayState(p = {}) {
	const today = moment().format("YYYY-MM-DD");
	const startDate = p.startDate || today;
	const numberOfDays = p.numberOfDays || 3;
	const endDate = moment(startDate).add(numberOfDays - 1, 'days').format("YYYY-MM-DD");

	const dateColumns = [];
	const processMoment = moment(startDate);
	let processDate = '';

	const getDisplayPieces = (mom) => {
		return {
			day: mom.format("D"),
			month: mom.format("MMM"),
			year: mom.format("YYYY"),
		};
	};

	const { nodIsLarge } = getNumberOfDaysBreakPoint(numberOfDays);
	const largeStyle = { fontSize : '80%' };

	const startDisplayPieces = getDisplayPieces(processMoment);
	while(processDate !== endDate) {
		processDate = processMoment.format('YYYY-MM-DD');

		let display = processMoment.format("ddd M/D");
		if (nodIsLarge) {
			display = (<Fragment>
				<div style={largeStyle}>{processMoment.format("M/D")}</div>
				<div style={largeStyle}>{processMoment.format("ddd")}</div>
			</Fragment>);
		}

		processMoment.add(1, 'days');
		dateColumns.push({
			date: processDate,
			display,
		});
	}
	processMoment.subtract(1, 'days');
	const endDisplayPieces = getDisplayPieces(processMoment);

	const title = (startDisplayPieces.year === endDisplayPieces.year) ?
		`${startDisplayPieces.month} ${startDisplayPieces.day} - ` +
		`${endDisplayPieces.month} ${endDisplayPieces.day}, ${endDisplayPieces.year}` :
		`${startDisplayPieces.month} ${startDisplayPieces.day}, ${startDisplayPieces.year} - ` +
		` ${endDisplayPieces.month} ${endDisplayPieces.day}, ${endDisplayPieces.year}`;

	return {
		dateRangeTitle: title,
		today: moment().format("YYYY-MM-DD"),
		startDate,
		endDate,
		dateColumns,
		numberOfDays,
	}
}

class DriverRoomSchedule extends Component {

	constructor(props){
		super(props);
		const locationIdInUrl = _.get(this.props, ['match', 'params', 'locationId']);
		const shiftIdInUrl = _.get(this.props, ['match', 'params', 'shiftId']);
		const securityTokenInUrl = _.get(this.props, ['match', 'params', 'securityToken']);

		this.state = {
			locationIdInUrl : (locationIdInUrl) ? parseInt(locationIdInUrl, 10) : undefined,
			shiftIdInUrl : (shiftIdInUrl) ? parseInt(shiftIdInUrl, 10) : undefined,
			securityTokenInUrl : securityTokenInUrl,
			errors : [],
			...getControlDisplayState({
				startDate :  moment().format("YYYY-MM-DD"),
				numberOfDays : 28,
			}),
		};
	}

	componentDidMount () {
		//- Only used for updates
		const { locationIdInUrl, shiftIdInUrl } = this.state;
		if (!locationIdInUrl || !shiftIdInUrl) {
			return;
		}
		this.search();
	}

	getInputProps = (path, defaultValue) => {
		return {
			key : path,
			path,
			value  : this.getValue(path, defaultValue),
			checked  : this.getValue(path, defaultValue),
			error : this.getError(path),
			onChange : this.onChange,
			gridProps : { md : 12 },
		};
	};

	getValue  = (path, defaultValue) => {
		const _d = (_.isUndefined(defaultValue)) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { locationId, shiftId } = this.state;

		if (locationId !== prevState.locationId) {
			this.setState({ locationIdInUrl : locationId }, this.checkForRedirect);
		}

		if (shiftId !== prevState.shiftId) {
			this.setState({ shiftIdInUrl : shiftId }, this.checkForRedirect);
		}
	}

	checkForRedirect = () => {
		const { locationIdInUrl, shiftIdInUrl} = this.state;

		if (locationIdInUrl && shiftIdInUrl) {
			this.props.history.push(
				`/minimal/driverRoomSchedule/${locationIdInUrl}/${shiftIdInUrl}`
			);
			this.search();
		}
	};

	onChange = (value, path, error) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);

		if (error) {
			formFieldError[path] = error;
		} else {
			delete formFieldError[path];
		}
		newState.formFieldError = formFieldError;
		this.setState(newState);
	};

	search = () => {
		const { startDate, endDate, locationIdInUrl, shiftIdInUrl, securityTokenInUrl } = this.state;
		this.setState({ searching: true });

		async.waterfall([
			callback => {

				let method = 'workDay.search';
				const params =  {
					startDate,
					endDate,
					locationIds : [locationIdInUrl],
					shiftIds : [shiftIdInUrl],
				};

				if (securityTokenInUrl) {
					method = 'workDay.tokenAuth.search';
					params.securityToken = securityTokenInUrl;
				}

				post({
					method,
					params,
					callback
				});
			},
		], (err, r) => {
			if (err) {
				return this.setState({
					searching: false,
					searchErrors: err,
				});
			}

			this.setState({
				searching: false,
				searchResult: r,
			});
		});
	};

	render() {
		const {classes, permissions} = this.props;

		const { securityTokenInUrl } = this.state;
		if (!securityTokenInUrl) {
			if (!permissions) {
				return (<div>Fetching permissions...</div>);
			}

			if (!_.includes(permissions,'canUpdateScheduling')) {
				return (<div>You do not have valid permissions to view this page.</div>);
			}
		}

		const { locationIdInUrl, shiftIdInUrl } = this.state;

		if (!locationIdInUrl || !shiftIdInUrl) {
			return (
				<div className={classes.noLocationIdContainer}>
					<div className={classes.pageBackground} />
					<div className={classes.noLocationInner}>
						<div style={{marginBottom : 30 }}>
							First pick a terminal, then the browser will redirect to a new URL that will
							auto refresh a schedule for the driver room
						</div>

						<FormCheckbox
							{...this.getInputProps('useSecurityToken', false)}
							label={'Include URL Auth Token'}
						/>

						<LocationSelect
							{...this.getInputProps('locationId')}
							label={'Pick Terminal'}
						/>

						<ShiftSelect
							{...this.getInputProps('shiftId')}
							label={'Pick Shift'}
						/>

					</div>
				</div>
			);
		}

		return (
			<div className={classes.root}>
			<div className={classes.pageBackground} />
			<div className={classes.aspectRatio} />
			<div className={classes.inner}>
				{ this.renderSchedule() }
			</div>
		</div>);
	}

	renderSchedule = () => {
		const {
			searchResult,
			locationIdInUrl,
			shiftIdInUrl,
			numberOfDays,
			today,
			dateColumns,
		} = this.state;

		return (
			<DriverRoomBody
				today={today}
				sortBy={'lastName'}
				numberOfDays={numberOfDays}
				locationIds={[locationIdInUrl]}
				dateColumns={dateColumns}
				searchResult={searchResult}
				refreshCalendarData={_.noop}
				useShiftIdAsHeader={shiftIdInUrl}
			/>
		);
	}
}

DriverRoomSchedule.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
])(DriverRoomSchedule);

